module.exports = __webpack_public_path__ + "static/media/hero_patient_es_text@2x.5674ba2c.png";